import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  submenu: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});
